import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { executeQuery } from '../../graphql';
import { validatePlateNumber } from '../../graphql/queries';
import { executeMutation } from '../../graphql';
import { combinationRecommender } from '../../graphql/mutations';
import HeroComboChecker from '../../components/HeroComboChecker';
import HomePromo from '../../components/HomePromo';
import CTATiles from '../../components/CTATiles';
import BestSellers from '../../components/BestSellers';
import HomeContentBlock from '../../components/HomeContentBlock';
import PromoBanner from '../../components/PromoBanner';
import { useHomepageContent } from '../../hooks/useHomepageContent';
import './index.module.css';



const outageMessage   = import.meta.env.VITE_OUTAGE_BANNER_MESSAGE;
const outageLinkUrl   = import.meta.env.VITE_OUTAGE_BANNER_LINK_URL;
const outageLinkLabel = import.meta.env.VITE_OUTAGE_BANNER_LINK_LABEL;

const HomePage = () => {
  const { bestSellers, heroPromos, ctaTiles, contentBlock } = useHomepageContent();
  const [recommendations, setRecommendations] = useState([]);
  const [recommendationsLoading, setRecommendationsLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();

  const handleCheckCombo = async (combo, vehicleType) => {
    setServerError(null);
    setRecommendations([]);

    try {
      const result = await executeQuery(validatePlateNumber, {
        PlateCombo: combo,
        VehicleType: vehicleType === 'car' ? 1 : 2,
        SalesChannel: 1
      });

      const isAvailable = result?.getPlateRuleEngineStatus?.Status === 1;

      if (!isAvailable) {
        setRecommendationsLoading(true);
        executeMutation(combinationRecommender, {
          input: {
            plateNumber: combo,
            groupName: '',
            vehicleType: vehicleType === 'car' ? 'Car' : 'Motorbike',
            maxNumberOfRecommendations: 6
          }
        })
          .then((recResult) => {
            const body = recResult?.recommender?.body;
            if (!body) return;
            const parsed = typeof body === 'string' ? JSON.parse(body) : body;
            const recs = parsed.recommendations || parsed.data || parsed || [];
            setRecommendations(recs.slice(0, 6).map((r) => r.PlateCombo || r.combo || r));
          })
          .catch(() => {})
          .finally(() => setRecommendationsLoading(false));
      }

      return isAvailable;
    } catch {
      setServerError('We are unable to check your combination at this time. Please try again later.');
      return false;
    }
  };

  return (
    <div id="content">
      {outageMessage && (
        <PromoBanner
          content={outageMessage}
          linkUrl={outageLinkUrl}
          buttonLabel={outageLinkLabel}
          bgColor="#FFD700"
          fgColor="#000"
          allowDismissal={true}
        />
      )}
      <div className="home-hero">
        <h1 className="visuallyhidden">Custom Plates | Personalised Plates Victoria</h1>
        <div className="home-hero__cols">
          <div className="home-hero__col">
            <HeroComboChecker
              onCheckCombo={handleCheckCombo}
              recommendations={recommendations}
              recommendationsLoading={recommendationsLoading}
              serverError={serverError}
            />
          </div>
          <div className="home-hero__col">
            <HomePromo content={heroPromos} />
          </div>
        </div>
      </div>

      <CTATiles content={ctaTiles} />

      <BestSellers content={bestSellers} />

      <HomeContentBlock content={contentBlock} />
    </div>
  );
};

export default HomePage;
